var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4000 1392",
    width: 1000,
    height: 348,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(923,239)",
    d: "m0 0h269l4 1-2 4-53 53-5 6-8 7-10 11h-2v2h-2v2h-2v2h-2v2h-2l-2 4-12 12h-2l-2 4-467 467-4 1-8-7-127-127-1-4 7-8 358-358h2l2-4 16-16h2l2-4 8-8h2l2-4h2l2-4h2l2-4h2l1-3 5-5h2l2-4h2l2-4 13-12z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,643)",
    d: "m0 0h108l165 1-2 5-20 20-1 2h-2l-2 4-6 5-7 8-129 129h-2v2l-4 4h-2l-2 4-15 14-5 6-8 7-26 26v5l116 116 6 5 7 8 10 9v2l3 1 7 8 8 7 11 12 7 6 7 8 11 11 7 8 30 30 2 3-1 4-3 1h-269l-2-1v-6l-7-5v-2h-2l-7-8-7-7-2-1v-2h-2v-2h-2v-2h-2v-2h-2v-2l-4-2-50-50v-2h-2v-2l-4-2-142-142 1-4 59-59 7-8 8-7 9-10 9-8 7-8 5-4 6-7h2l2-4 6-5 17-17 7-6 2-3h2l2-4z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3065,567)",
    d: "m0 0h46l24 4 24 8 21 10 16 11 12 11 6 5 7 8 9 11 9 15 8 16 6 16 5 18 4 22 2 26v13l-1 12-1 2h-290l5 28 6 20 7 15 7 11 8 10 9 10 14 11 19 10 18 6 10 2 13 1h12l15-1 17-4 16-7 11-6 12-9 3-1v-2h2v-2l5-5 8-9 7-10 6-9 5 1 46 23 2 2-1 5-11 18-13 16-7 7-5 6-11 9-15 11-10 6-16 7-18 6-25 5-25 2h-17l-18-2-20-4-21-7-23-11-16-11-13-11-16-16-14-19-14-27-5-12-5-17-6-31-2-30 3-31 6-29 7-21 13-27 10-15 7-10h2l2-4 8-9 8-7 14-11 18-11 17-8 23-7zm10 57-17 3-15 5-13 7-12 9-14 14-10 14-8 15-7 20-3 8v3h220v-8l-5-20-8-18-9-14-8-9-14-11-14-8-12-5-17-4-8-1z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,431)",
    d: "m0 0h298v59l-6 1h-231v174l4-1h209l2 1v58l-1 1-203 1-11-1v221l-2 1h-58l-1-1-1-74v-439z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,579)",
    d: "m0 0h63l1 5v219l2 24 4 17 6 15 6 10 5 6v2l4 2 11 8 14 7 15 4 12 1h14l16-2 10-3 16-8 12-8 12-11 11-14 8-14 8-21 3-15 1-224h63l1 365-3 2h-56l-1-1v-52h-2l-2 5-7 9-12 13-11 9-10 7-21 11-15 5-18 4-7 1-25 1-19-2-20-4-16-6-17-9-14-11-7-7-11-15-9-16-6-16-6-27-2-16-1-14z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2730,475)",
    d: "m0 0h63l1 1 1 96-1 7h88v56l-5 1h-82v202l1 20 3 13 6 11 7 7 9 5 10 3h25l13-4 10-5 3-2h3v62l-9 4-16 4-7 1-24 1-18-2-16-4-16-7-11-7-10-9-7-7-9-14-6-15-4-15-2-20-1-24v-198l-62-1v-56l5-1 57 1v-103z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2479,475)",
    d: "m0 0h62l1 1v103h89l1 1v53l-1 2h-89l1 213 2 16 5 14 10 11 12 6 7 2h24l12-3 12-6 5-2 1 1v60l-6 4-14 4-11 2-26 1-17-2-16-4-16-7-11-7-10-9-7-7-7-11-6-12-4-11-3-15v-238h-64l-1-1v-55l5-1 60 1z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3464,566)",
    d: "m0 0 24 1 23 5 3 2 1 66-1 2-10-3-17-5-10-2h-30l-16 4-16 8-10 8-11 10-12 16-8 16-5 14-4 21-1 42v173l-2 2h-60l-1-1v-366l1-1h57l2 1v55l1-1 1-4 4-4 5-9 9-11 10-10 16-11 14-8 16-6 14-3z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1916,431)",
    d: "m0 0h63l1 513-3 2h-60l-1-1-1-86v-421z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.c8457ce046e41fa5085ce186435403cb.svg";
export { ForwardRef as ReactComponent };